import { CartButton } from '../AddToCart/Button';
import { productLinkBuilder } from 'common-next/src/components/common-functions';
import type { ProductCardProps } from './ProductCard';
import ProductCardPrice from './ProductCardPrice';
import { getProductCardButtonText } from './ProductCard.utils';

const ProductInfoDetailed = (props: ProductCardProps) => {
  const {
    productName,
    productPrice,
    productVintage,
    productPriceOriginal,
    productNumberOfBottles,
    productMemberPrice,
    handleCmlpDLEvent,
  } = props || {};
  const { productCardButton, productCode } = props || {};

  const productUrl = productLinkBuilder(productName, productVintage, productCode);

  return (
    <div className="product-card__info">
      {/* Card info Top */}
      {productName && (
        <div className="product-card__info-top">
          <div className="product-name-box">
            <a href={productUrl} onClick={() => handleCmlpDLEvent?.('headline', undefined, productUrl)}>
              <label className="product-name h8">
                {productName} {productVintage}
              </label>
            </a>
          </div>
        </div>
      )}

      {/* Card info Bottom */}
      <div className="product-card__info-bottom">
        <ProductCardPrice
          productPrice={productPrice}
          productPriceOriginal={productPriceOriginal}
          productNumberOfBottles={productNumberOfBottles}
          productMemberPrice={productMemberPrice}
          productName={productName}
          productCode={productCode}
          multiViewPriceDiff={props.multiViewPriceDiff}
        />

        {productCardButton && (
          <div className="product-card-button">
            {productCardButton.toLocaleLowerCase() === 'Add to Basket'.toLocaleLowerCase() ? (
              <CartButton
                itemCode={productCode}
                qty={'1'}
                buttonText={getProductCardButtonText(productCardButton)}
                hit={props.product}
              />
            ) : (
              <a href={productLinkBuilder(productName, productVintage, productCode)} className="view-product-button">
                {productCardButton}
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductInfoDetailed;
